/* Publish by EComposer at 2026-10-07 19:50:52*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-lz8dbjd6mlr"]=  window.__ectimmers["ecom-lz8dbjd6mlr"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-lz8dbjd6mlr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lz8dbjd6mlr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z46w6ecomrr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z46w6ecomrr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rrfllvp3bnh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rrfllvp3bnh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uakhv3k2pl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uakhv3k2pl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dx2asikt51').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dx2asikt51', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l9oj29mhkzq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l9oj29mhkzq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t815flle739').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t815flle739', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r3573yi7q6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r3573yi7q6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hoig1t9k8ej').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hoig1t9k8ej', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kq0mb21pjgb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kq0mb21pjgb', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-88khrpoqkvj"]=  window.__ectimmers["ecom-88khrpoqkvj"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-88khrpoqkvj"]["sdfu429pl"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-88khrpoqkvj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-88khrpoqkvj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w66uch2sjy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w66uch2sjy', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hinhna0luj4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hinhna0luj4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3mtfor1pcgn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3mtfor1pcgn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ipvd51jutv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ipvd51jutv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l95ps2q10f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l95ps2q10f', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hmnzlwhb9lw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hmnzlwhb9lw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6zjbmgxeerm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6zjbmgxeerm', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-gl01jodgq18"]=  window.__ectimmers["ecom-gl01jodgq18"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-gl01jodgq18"]["669bo3bj8"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-gl01jodgq18').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gl01jodgq18', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7xeicnxsgzy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7xeicnxsgzy', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rg1p3qwqmvh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rg1p3qwqmvh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eh4et0ymnym').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eh4et0ymnym', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-354pru2ep6b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-354pru2ep6b', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e5ug1elntv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e5ug1elntv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0a0y8phosvm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0a0y8phosvm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-thcgi5s6h2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-thcgi5s6h2', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yugel4wemnq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yugel4wemnq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4g2o8auaj6v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4g2o8auaj6v', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7qgg31hc5s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7qgg31hc5s', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}